import { render, staticRenderFns } from "./salesTableShhx.vue?vue&type=template&id=41948b9f"
import script from "./salesTableShhx.vue?vue&type=script&lang=js"
export * from "./salesTableShhx.vue?vue&type=script&lang=js"
import style0 from "./salesTableShhx.vue?vue&type=style&index=0&id=41948b9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports